/**
 * Utility format helpers — Sprint Visual Brief 2A r7b (Agent A SHELL).
 *
 * Deterministic color hash for avatars: same input always returns same
 * color. Uses simple djb2-like hash over a Lume canonical palette
 * (paleta B v2.3.0 — warm earth tones complementares ao DS).
 *
 * Palette curada para garantir contraste WCAG AA com fg-on-accent (#FFF).
 * 8 cores — suficiente para evitar colisões visuais óbvias em listas <100.
 */

const AVATAR_PALETTE: readonly string[] = [
  '#D97706', // brand-primary
  '#92400E', // brand-active
  '#5C5E80', // ai-fg
  '#1D4ED8', // info-fg
  '#B45309', // warning-fg
  '#65A30D', // success-ish
  '#9333EA', // purple
  '#0E7490', // teal
];

/**
 * Hash determinístico (djb2) sobre string. Returns int >= 0.
 */
function djb2(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/**
 * Cor determinística para avatar. Mesmo input → mesma cor.
 */
export function avatarColorFor(key: string): string {
  if (key === '') return AVATAR_PALETTE[0] ?? '#D97706';
  const idx = djb2(key) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[idx] ?? AVATAR_PALETTE[0] ?? '#D97706';
}

/**
 * Iniciais canônicas (até 2 caracteres uppercase) a partir do nome
 * humano. "Carolina Andrade" → "CA"; "Roberta" → "R"; vazio → "?".
 */
export function initialsOf(name: string | null | undefined): string {
  if (name === null || name === undefined || name === '') return '?';
  const parts = name
    .trim()
    .split(/\s+/)
    .filter((p) => p.length > 0);
  if (parts.length === 0) return '?';
  if (parts.length === 1) {
    const first = parts[0];
    return first !== undefined && first.length > 0 ? first.charAt(0).toUpperCase() : '?';
  }
  const first = parts[0];
  const last = parts[parts.length - 1];
  const f = first?.charAt(0).toUpperCase() ?? '';
  const l = last?.charAt(0).toUpperCase() ?? '';
  const combined = `${f}${l}`;
  return combined.length > 0 ? combined : '?';
}
